import { Box, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

function RuleDescription({ description }: { description: string | null | undefined }) {
  if (!description) {
    return null
  }

  function extractTextAndValues(text: string) {
    const regex = /([^$]+)\(\$value:([^)]+)\)/g
    const matches = []
    let match

    while ((match = regex.exec(text)) !== null) {
      const [, preText, value] = match
      matches.push({ text: preText, value: value })
    }

    return matches
  }

  const tagType = (index: number) => {
    if (index % 2 === 0) {
      return 'malibu'
    }

    return 'purple'
  }

  return (
    <Box flexDirection="row" flexWrap="wrap" alignItems="center" gap="s4">
      {i18n.t('settings.approvals.approval_rule.description_rule') + ' '}
      {extractTextAndValues(description).map(
        (textBlock: { text: string | undefined; value: string | undefined }, index) => {
          return (
            <>
              <>{textBlock.text}</>
              <Tag type={tagType(index)}>{textBlock.value}</Tag>
            </>
          )
        }
      )}
    </Box>
  )
}

export default RuleDescription
